import { ResponseServiceData } from "../../../admin/manage-services/models/response-models/response-service-data";
import { ResponseClientPricingData } from "../../clients/models/client-pricing";
import { ServiceTypes } from "../../../../utills/enums/service-types";


export function findServicePriceForJob(
    serviceData: ResponseServiceData,
    job: {
        serviceId: number;
        sourceLanguageId?: number;
        targetLanguageId?: number;
        unitId: number;
    }
): { rate: number; unitId: number; rateTypeId: number } | null {
    
    if (!serviceData?.priceList?.length) return null;

    const match = serviceData.priceList.find(priceList => {
        // Basic matching - service and unit are always required
        const serviceMatch = priceList.serviceId === job.serviceId;
        const unitMatch = priceList.units?.some(unit => unit.id === job.unitId);
        
        if (!serviceMatch || !unitMatch) return false;

        // Language matching based on service type
        if (serviceData.serviceTypeId === ServiceTypes.Monolingual) {
            // Monolingual: requires source language match
            return priceList.sourceLanguageId === job.sourceLanguageId;
        }
        
        if (serviceData.serviceTypeId === ServiceTypes.Bilingual) {
            // Bilingual: requires both source and target language match
            const sourceMatch = priceList.sourceLanguageId === job.sourceLanguageId;
            const targetMatch = Array.isArray(priceList.targetLanguages) &&
                priceList.targetLanguages.some(tl => Number(tl.id) === Number(job.targetLanguageId));
            return sourceMatch && targetMatch;
        }

        // For other service types (no language requirements), just match service and unit
        return true;
    });

    if (match) {
        return {
            rate: match.rate,
            unitId: match.units[0].id,
            rateTypeId: 1
        };
    }

    return null;
}

export function findClientPriceForJob(
    serviceData: ResponseServiceData,
    clientPriceList: ResponseClientPricingData[],
    job: {
        serviceId: number;
        sourceLanguageId?: number;
        targetLanguageId?: number;
        unitId: number;
    }
): { rate: number; unitId: number; rateTypeId: number } | null {
    
    if (!clientPriceList?.length) return null;

    const match = clientPriceList.find(priceItem => {
        // Basic matching
        const serviceMatch = priceItem.serviceId === job.serviceId;
        const unitMatch = priceItem.unitId === job.unitId;
        
        if (!serviceMatch || !unitMatch) return false;

        // Language matching based on service type
        if (serviceData.serviceTypeId === ServiceTypes.Bilingual) {
            // Bilingual: requires both source and target language match
            const sourceMatch = priceItem.sourceLanguageId === job.sourceLanguageId;
            const targetMatch = priceItem.targetLanguageId === job.targetLanguageId;
            return sourceMatch && targetMatch;
        }

        if (serviceData.serviceTypeId === ServiceTypes.Monolingual) {
            // Monolingual: requires only source language match
            const sourceMatch = priceItem.sourceLanguageId === job.sourceLanguageId;
            return sourceMatch;
        }

        // For other service types, just match service and unit
        return true;
    });

    if (match) {
        return {
            rate: match.rate,
            unitId: match.unitId,
            rateTypeId: match.rateTypeId
        };
    }

    return null;
}



